import analytics from '@viewlift/analytics/analytics-core/index.cjs';
import googleAnalytics from '@viewlift/analytics/google-analytics/index.cjs';
import userBeacon from '@viewlift/analytics/user-beacon/index.cjs';
import fbPixel from '@viewlift/analytics/facebook/index.cjs';
import { convivaECO, convivaVideoSensor } from '@viewlift/analytics/conviva/index.cjs';
import { parseJSON } from "../OnBoarding-V2/utils/parseJSON";
import { getDeviceId, getToken } from "../helpers";
import Cookies from 'js-cookie';
import jwtDecode from 'jwt-decode';
import { getStorageItem } from './storageManager';
import { version } from '../../package.json';
import { initDatadogRum } from '@viewlift/analytics/datadog-rum/index.cjs.js';
export default async function trackEvent(eventName, payload, gaId) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    let commonPayload = {
        platform: 'Web',
        etstamp: Date.now(),
        // device_id : getDeviceId() || "", //This violates GDPR/Google terms
    };
    const getCookie = Cookies.get("cc_cookie");
    const getparsedCookie = getCookie && JSON.parse(getCookie);
    const oneTrustCookie = window === null || window === void 0 ? void 0 : window.fireGaEvents;
    if (((_a = getparsedCookie === null || getparsedCookie === void 0 ? void 0 : getparsedCookie.level) === null || _a === void 0 ? void 0 : _a.includes("performanceCookie")) || oneTrustCookie) {
        // Targeting Cookies(optional) category will control GTM, FB and Clevertap loading
        // Performance Cookies category will control GA loading.
        // if(getparsedCookie?.level?.includes("performanceCookie")){
        if (typeof window !== 'undefined' && (window === null || window === void 0 ? void 0 : window.app_data)) {
            let trackingID = gaId || ((_d = (_c = (_b = window === null || window === void 0 ? void 0 : window.app_data) === null || _b === void 0 ? void 0 : _b.appcmsPlatform) === null || _c === void 0 ? void 0 : _c.analytics) === null || _d === void 0 ? void 0 : _d.googleAnalyticsId);
            if (window === null || window === void 0 ? void 0 : window.dataLayer) {
                window.dataLayer.push({
                    'event': eventName,
                    ...payload
                });
            }
            if (trackingID) {
                const userData = getStorageItem("AuthenticationStore");
                const userSubscriptionPlanId = ((_f = (_e = userData === null || userData === void 0 ? void 0 : userData.user) === null || _e === void 0 ? void 0 : _e.monetizationPlan) === null || _f === void 0 ? void 0 : _f.id) || '';
                const userSubscriptionPlanName = ((_h = (_g = userData === null || userData === void 0 ? void 0 : userData.user) === null || _g === void 0 ? void 0 : _g.monetizationPlan) === null || _h === void 0 ? void 0 : _h.name) || '';
                const currentSelectedPlanObj = sessionStorage.getItem('currentPlan') ? parseJSON(sessionStorage.getItem('currentPlan')) : '';
                let currentSelectedPlanId = '';
                let currentSelectedPlanName = '';
                if (currentSelectedPlanObj) {
                    currentSelectedPlanId = currentSelectedPlanObj === null || currentSelectedPlanObj === void 0 ? void 0 : currentSelectedPlanObj.id;
                    currentSelectedPlanName = currentSelectedPlanObj === null || currentSelectedPlanObj === void 0 ? void 0 : currentSelectedPlanObj.name;
                }
                const userProperties = {
                    device_platform: 'Web',
                    logged_in_status: ((_j = userData === null || userData === void 0 ? void 0 : userData.user) === null || _j === void 0 ? void 0 : _j.userId) ? 'Yes' : 'No',
                    subscribed_status: ((_k = userData === null || userData === void 0 ? void 0 : userData.user) === null || _k === void 0 ? void 0 : _k.isSubscribed) ? 'Yes' : 'No',
                    device_id: getDeviceId() || '',
                    subscription_plan: userSubscriptionPlanName || currentSelectedPlanName || '',
                    plan_id: userSubscriptionPlanId || currentSelectedPlanId || '',
                    user_city: ((_l = userData === null || userData === void 0 ? void 0 : userData.user) === null || _l === void 0 ? void 0 : _l.city) || ''
                };
                analytics({
                    app: 'analytics',
                    eventName: eventName,
                    plugins: [
                        googleAnalytics({
                            trackingId: trackingID,
                            initialize: () => {
                            },
                            payload: { ...payload, ...commonPayload },
                            userProperties: userProperties ? userProperties : null
                        }),
                    ]
                });
            }
        }
        // }
    }
}
export async function trackUserEvent(payload) {
    var _a, _b, _c;
    let token = await getToken();
    if (typeof window !== 'undefined') {
        return analytics({
            app: 'user-analytics',
            apiBaseUrl: (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsMain) === null || _b === void 0 ? void 0 : _b.apiConfig) === null || _c === void 0 ? void 0 : _c.userBeaconUrl,
            token: token,
            plugins: [
                userBeacon({
                    initialize: () => {
                    },
                    payload: payload
                }),
            ]
        });
    }
}
export function trackFbEvent(eventName, payload) {
    var _a, _b, _c;
    if (typeof window === 'undefined') {
        return;
    }
    const conversionApi = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsMain) === null || _b === void 0 ? void 0 : _b.analytics) === null || _c === void 0 ? void 0 : _c.conversionApi;
    return getToken()
        .then((token) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        try {
            return analytics({
                app: 'fb-analytics',
                eventName: eventName,
                trackingBaseUrl: ((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsMain) === null || _b === void 0 ? void 0 : _b.apiConfig) === null || _c === void 0 ? void 0 : _c.trackingBaseUrl) || ((_e = (_d = window === null || window === void 0 ? void 0 : window.app_data) === null || _d === void 0 ? void 0 : _d.appcmsMain) === null || _e === void 0 ? void 0 : _e.trackingBaseUrl),
                apiBaseUrl: (_h = (_g = (_f = window === null || window === void 0 ? void 0 : window.app_data) === null || _f === void 0 ? void 0 : _f.appcmsMain) === null || _g === void 0 ? void 0 : _g.apiConfig) === null || _h === void 0 ? void 0 : _h.apiBaseUrl,
                eventType: 'fbConversionAPI',
                platformDetails: {
                    site: (_k = (_j = window === null || window === void 0 ? void 0 : window.app_data) === null || _j === void 0 ? void 0 : _j.appcmsMain) === null || _k === void 0 ? void 0 : _k.internalName,
                    conversionApiEnabled: conversionApi === null || conversionApi === void 0 ? void 0 : conversionApi.conversionApi,
                    pixelId: conversionApi === null || conversionApi === void 0 ? void 0 : conversionApi.pixelID,
                    device: 'web',
                    token: token,
                },
                plugins: [
                    fbPixel({
                        initialize: () => { },
                        payload: payload,
                    }),
                ],
            });
        }
        catch (error) {
            console.error('trackFbEvent failed', error);
        }
    })
        .catch((error) => {
        console.error('trackFbEvent failed', error);
    });
}
export function trackPixelEvent(eventName, payload) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    if (typeof window === 'undefined') {
        return;
    }
    const conversionApi = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsMain) === null || _b === void 0 ? void 0 : _b.analytics) === null || _c === void 0 ? void 0 : _c.conversionApi;
    try {
        return (_q = (_p = analytics({
            app: 'fb-analytics',
            eventName: eventName,
            trackingBaseUrl: ((_f = (_e = (_d = window === null || window === void 0 ? void 0 : window.app_data) === null || _d === void 0 ? void 0 : _d.appcmsMain) === null || _e === void 0 ? void 0 : _e.apiConfig) === null || _f === void 0 ? void 0 : _f.trackingBaseUrl) || ((_h = (_g = window === null || window === void 0 ? void 0 : window.app_data) === null || _g === void 0 ? void 0 : _g.appcmsMain) === null || _h === void 0 ? void 0 : _h.trackingBaseUrl),
            apiBaseUrl: (_l = (_k = (_j = window === null || window === void 0 ? void 0 : window.app_data) === null || _j === void 0 ? void 0 : _j.appcmsMain) === null || _k === void 0 ? void 0 : _k.apiConfig) === null || _l === void 0 ? void 0 : _l.apiBaseUrl,
            eventType: 'fbPixel',
            platformDetails: {
                site: (_o = (_m = window === null || window === void 0 ? void 0 : window.app_data) === null || _m === void 0 ? void 0 : _m.appcmsMain) === null || _o === void 0 ? void 0 : _o.internalName,
                conversionApiEnabled: conversionApi === null || conversionApi === void 0 ? void 0 : conversionApi.conversionApi,
                pixelId: conversionApi === null || conversionApi === void 0 ? void 0 : conversionApi.pixelID,
            },
            plugins: [
                fbPixel({
                    initialize: () => { },
                    payload: payload,
                }),
            ],
        })) === null || _p === void 0 ? void 0 : _p.catch) === null || _q === void 0 ? void 0 : _q.call(_p, (error) => {
            console.error('trackPixelEvent failed', error);
        });
    }
    catch (error) {
        console.error('trackPixelEvent failed', error);
    }
}
export const getUserProperties = async () => {
    var _a, _b;
    const userData = getStorageItem("AuthenticationStore");
    const userProperties = {
        device_platform: 'Web',
        logged_in_status: ((_a = userData === null || userData === void 0 ? void 0 : userData.user) === null || _a === void 0 ? void 0 : _a.userId) ? 'Yes' : 'No',
        subscribed_status: ((_b = userData === null || userData === void 0 ? void 0 : userData.user) === null || _b === void 0 ? void 0 : _b.isSubscribed) ? 'Yes' : 'No',
        // device_id: getDeviceId() || '', //This violates GDPR/Google terms
    };
    return userProperties;
};
export const trackBrazeEvents = (eventName, payload) => {
    var _a, _b, _c;
    let brazeObject = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsPlatform) === null || _b === void 0 ? void 0 : _b.notifications) === null || _c === void 0 ? void 0 : _c.braze;
    if (brazeObject && (brazeObject === null || brazeObject === void 0 ? void 0 : brazeObject.apiKey) && (brazeObject === null || brazeObject === void 0 ? void 0 : brazeObject.baseUrl)) {
        import(
        /* webpackExports: ["logCustomEvent"] */
        "@braze/web-sdk").then(({ logCustomEvent }) => {
            logCustomEvent(eventName, payload);
        });
    }
};
export const trackRKPEvent = (ename) => {
    window.rkp('event', ename);
};
export function trackConvivaEco(eventName, payload) {
    var _a, _b, _c;
    if (typeof window !== 'undefined') {
        const { customerKey, appName, enabled } = ((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsPlatform) === null || _b === void 0 ? void 0 : _b.analytics) === null || _c === void 0 ? void 0 : _c.convivaConfig) || {};
        if (!customerKey || !enabled) {
            return;
        }
        getToken().then(async (token) => {
            var _a, _b;
            const userDetail = jwtDecode(token);
            const userData = (getStorageItem("AuthenticationStore")) || {};
            const userId = ((_a = userData === null || userData === void 0 ? void 0 : userData.user) === null || _a === void 0 ? void 0 : _a.userId) || ((_b = userDetail === null || userDetail === void 0 ? void 0 : userDetail.userId) !== null && _b !== void 0 ? _b : '');
            return analytics({
                app: 'conviva-eco',
                eventName: eventName,
                eventType: eventName,
                plugins: [
                    convivaECO({
                        initialize: () => {
                        },
                        initConfig: { appName: appName || "WEB", customerKey, userId },
                        payload: payload,
                    }),
                ]
            });
        });
    }
}
export function trackConvivaVideoSensor(eventName, payload) {
    var _a, _b, _c;
    if (typeof window !== 'undefined') {
        const { customerKey, enabled } = ((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsPlatform) === null || _b === void 0 ? void 0 : _b.analytics) === null || _c === void 0 ? void 0 : _c.convivaConfig) || {};
        if (!customerKey || !enabled)
            return;
        return analytics({
            app: 'conviva-video',
            eventName: eventName,
            eventType: eventName,
            plugins: [
                convivaVideoSensor({
                    initialize: () => {
                        return true;
                    },
                    initConfig: { customerKey: customerKey, debug: false },
                    payload: payload,
                }),
            ]
        });
    }
}
export function getConvivaVideoSensorConfig(user) {
    var _a, _b, _c, _d, _e, _f;
    if (typeof window !== 'undefined') {
        const { enabled, appName, customerKey } = ((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsPlatform) === null || _b === void 0 ? void 0 : _b.analytics) === null || _c === void 0 ? void 0 : _c.convivaConfig) || {};
        const subscriptionData = ((_d = user === null || user === void 0 ? void 0 : user.userInfo) === null || _d === void 0 ? void 0 : _d.subscription) || (user === null || user === void 0 ? void 0 : user.subscription) || {};
        const paymentHandler = ((_e = subscriptionData === null || subscriptionData === void 0 ? void 0 : subscriptionData.subscriptionInfo) === null || _e === void 0 ? void 0 : _e.paymentHandler) || null;
        const tveProvider = ((_f = user === null || user === void 0 ? void 0 : user.tveMetadata) === null || _f === void 0 ? void 0 : _f.idpName) || null;
        const isUserVip = (user === null || user === void 0 ? void 0 : user.isVip) || false;
        const paymentHandlerType = isUserVip ? "FREE" : tveProvider ? "TVE" : paymentHandler;
        return {
            trackConvivaPlayerEvent: trackConvivaVideoSensor,
            appName: appName || "WEB",
            enable: customerKey && enabled,
            paymentHandler,
            tveProvider,
            customerKey: customerKey || "",
            gatewayUrl: `https://${customerKey}.ts-testonly.conviva.com`,
        };
    }
}
export function trackDatadogRum() {
    var _a, _b, _c, _d, _e;
    if (typeof window === "undefined")
        return;
    const dataDogConfig = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsPlatform) === null || _b === void 0 ? void 0 : _b.observability) === null || _c === void 0 ? void 0 : _c.datadogConfig;
    const { enable, applicationId, clientToken, datadogSite, preferredServiceName, environment } = dataDogConfig || {};
    // early return if Datadog RUM is not enabled in the configuration
    if (!enable)
        return;
    // Validate required Datadog configuration
    const missingConfigs = [
        !applicationId && "applicationId",
        !clientToken && "clientToken",
        !datadogSite && "datadogSite",
        !preferredServiceName && "preferredServiceName",
        !environment && "environment",
    ].filter(Boolean);
    if (missingConfigs.length > 0) {
        console.error("[Datadog] Initialize Failed - Incorrect Configuration. Missing:", missingConfigs.join(", "));
        return;
    }
    const dataDogSetting = {
        enable: true,
        applicationId,
        clientToken,
        preferredServiceName,
        environment,
        datadogSite: datadogSite,
        site: ((_e = (_d = window === null || window === void 0 ? void 0 : window.app_data) === null || _d === void 0 ? void 0 : _d.site) === null || _e === void 0 ? void 0 : _e.siteInternalName) || "",
        version: version || "0.0.1",
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackResources: true,
        trackUserInteractions: true,
        trackLongTasks: true,
    };
    // Initialize Datadog RUM
    try {
        // datadogRum.init(dataDogSetting);
        initDatadogRum(dataDogSetting);
    }
    catch (error) {
        console.error("[Datadog] Failed to initialize:", error);
    }
}
